export const URL_START = '/start-interview/comparison3';
export const DEFAULT_LOCALE = 'en';
export const INTERVIEW_TYPE = 'comparison-predefined';



// WEBPACK FOOTER //
// ./src/comparison-predefined/constants.js